import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ButtonModule }         from 'primeng/button';
import { SelectButtonModule }   from 'primeng/selectbutton';
import { CheckboxModule }       from 'primeng/checkbox';
import { OverlayPanelModule }   from 'primeng/overlaypanel';
import { ConfirmDialogModule }  from 'primeng/confirmdialog';

import { UnsubscribeComponent } from './unsubscribe.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,

    ButtonModule, SelectButtonModule, OverlayPanelModule, CheckboxModule, ConfirmDialogModule
  ],
  declarations: [UnsubscribeComponent],
  providers: [UnsubscribeComponent],
  exports: [UnsubscribeComponent]  
})
export class UnsubscribeModule {}
